import { useMutation } from 'react-query';

import { Api } from 'shared/types';
import postUpdatingOptionsSummary from '../services/postUpdatingOptionsSummary';

type Props = {
  apiUpdatingOptionsSummary: Api;
  saleDeviceId: string | null;
};

export const useUpdatingOptionsSummary = ({
  apiUpdatingOptionsSummary,
  saleDeviceId
}: Props) => {
  return useMutation(
    ({ token, body }: { token: string; body: Record<string, unknown> }) =>
      postUpdatingOptionsSummary({
        saleDeviceId,
        apiUpdatingOptionsSummary,
        token,
        body
      })
  );
};
